import React from 'react';
import BillPaymentDialog from './BillPaymentDialog';
import BillPaymentDialogService from '../services/BillPaymentDialogService';
import { observer } from 'mobx-react';

const BillPaymentDialogContainer = () => (
  <BillPaymentDialog
    isOpen={BillPaymentDialogService.isOpen}
    submitting={BillPaymentDialogService.submit.fetching}
    onChange={BillPaymentDialogService.form.setValue}
    onCancel={BillPaymentDialogService.handleCancel}
    onPay={BillPaymentDialogService.handlePay}
    values={BillPaymentDialogService.form.getValues()}
    errors={BillPaymentDialogService.form.errors}
  />
);

export default observer(BillPaymentDialogContainer);
